<template>
  <div id="ddslide" class=" ">
    <div class="ddslide-wrapper">
      <div class="ddslide-bg" v-on:click="closeSlide()"></div>
      <div class="ctpx-ddslide">
        <div class="close-button" v-on:click="closeSlide()">X</div>
        <div class="ctpx-slide-body">
          <div class="row">
            <div class="col-12 order-md-2 col-md-7">
              <h1>Great Choice!</h1>
              <div v-if="urlContains('upcycled-jacket-sm-md')">
                <h2>Renovo Jacket</h2>
                <p class="lead mb-0">Size: SM/MD</p>
              </div>
              <div v-else-if="urlContains('upcycled-jacket-lg-xl')">
                <h2>Renovo Jacket</h2>
                <p class="lead mb-0">Size: LG/XL</p>
              </div>
              <div v-else-if="urlContains('upcycled-vest-sm-md')">
                <h2>Renovo Vest</h2>
                <p class="lead mb-0">Size: SM/MD</p>
              </div>
              <div v-else-if="urlContains('upcycled-vest-lg-xl')">
                <h2>Renovo Vest</h2>
                <p class="lead mb-0">Size: LG/XL</p>
              </div>
              <p class="price lead">
                <span>{{ filterPrice(product.price) }}</span>
              </p>
              <p v-if="urlContains('upcycled-jacket')">
                Act fast - snag this "one of one" jacket upcycled from pre-loved
                Cotopaxi scraps before it's gone!
              </p>
              <p v-else-if="urlContains('upcycled-vest')">
                Act fast - snag this "one of one" vest upcycled from pre-loved
                Cotopaxi scraps before it's gone!
              </p>
              <p v-if="!delDiaApparel">
                Act fast—we can't hold this one-of-a-kind pack in your cart for
                very long. When it's gone, it's gone.
              </p>
              <div
                v-if="product.inventoryCount <= 0"
                class="add-to-cart-box sold-out"
              >
                <button class="btn btn-black">Sold Out</button>
              </div>
              <!-- .add-to-cart-box -->
              <div v-else class="add-to-cart-box">
                <button
                  id="AddToCart"
                  class="btn btn-black"
                  @click="addToCart(product)"
                  :data-id="product.variantId"
                >
                  Add to Cart -
                  <span class="price">{{ filterPrice(product.price) }}</span>
                </button>
              </div>
              <!-- .add-to-cart-box -->
              <div class="favorites" @click="toggleFavorite(product)">
                <img
                  v-if="!product.favorite"
                  src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav.svg"
                  loading="lazy"
                  alt="favorite icon"
                  class="favorite"
                />
                <img
                  v-else
                  src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav-full.svg"
                  loading="lazy"
                  alt="favorite icon"
                  class="favorite"
                />
                ADD TO FAVORITES
              </div>
              <div class="sizechart" v-if="delDiaApparel">
                <button @click="showSizemodal = true" class="size-guide">
                  Size Chart
                </button>
                <sizechart
                  :productTitle="'Renovo'"
                  v-if="showSizemodal"
                  @close="showSizemodal = false"
                />
              </div>

              <div class="d-none d-md-block">
                <div id="DY-compare"></div>
                <!--DY-compare-->
                <div id="DY-bundle"></div>
                <!--DY-bundle-->
                <!-- ==================== accordion-box ==================== -->
                <div class="accordion-box">
                  <div
                    class="accordion-item"
                    v-for="(accordion, index) in accordionContent"
                    :class="{ active: activeDrawer === index }"
                    :key="accordion.title"
                  >
                    <div
                      class="accordion-header"
                      @click="activateAccordion(index)"
                    >
                      <h4>{{ accordion.title }}</h4>
                    </div>
                    <!-- accordion-header -->
                    <div class="accordion-content">
                      <div v-html="accordion.content"></div>
                    </div>
                    <!-- accordion-content -->
                  </div>
                  <!-- .accordion-item -->
                </div>
                <!-- .accordion-box -->
              </div>
            </div>
            <!-- .col -->
            <div class="col-12 order-md-1 col-md-5">
              <div class="img-contain">
                <img
                  :src="product.images[0].src.replace('w_1024', 'w_350')"
                  :srcset="
                    product.images[0].src.replace('w_1024', 'w_700') + ' 2x'
                  "
                  itemprop="image"
                  class="img1"
                />
                <img
                  :src="product.images[1].src.replace('w_1024', 'w_350')"
                  :srcset="
                    product.images[1].src.replace('w_1024', 'w_700') + ' 2x'
                  "
                  itemprop="image"
                />
              </div>
            </div>
            <!-- .col -->
            <!-- //mobile accordion and dy divs bc of diff placement -->
            <div class="col-12 d-xs-block d-md-none">
              <div id="DY-compare"></div>
              <!--DY-compare-->
              <div id="DY-bundle"></div>
              <!--DY-bundle-->
              <!-- ==================== accordion-box ==================== -->
              <div class="accordion-box">
                <div
                  class="accordion-item"
                  v-for="(accordion, index) in accordionContent"
                  :class="{ active: activeDrawer === index }"
                  :key="accordion.title"
                >
                  <div
                    class="accordion-header"
                    @click="activateAccordion(index)"
                  >
                    <h4>{{ accordion.title }}</h4>
                  </div>
                  <!-- accordion-header -->
                  <div class="accordion-content">
                    <div v-html="accordion.content"></div>
                  </div>
                  <!-- accordion-content -->
                </div>
                <!-- .accordion-item -->
              </div>
              <!-- .accordion-box -->
            </div>
          </div>
          <!-- .row -->
          <div class="row">
            <div class="col-12">
              <div id="DY-features"></div>
            </div>
          </div>
          <!--.row-->
          <div v-if="lifestyleImgs" class="row gx-0 lifestyle">
            <div
              class="col-12 p-0 col-md-6"
              v-for="lifestyleImg in lifestyleImgs"
            >
              <div class="square">
                <img :src="lifestyleImg.url" />
              </div>
            </div>
          </div>
          <!--.row-->
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./ctrl-del-dia-slide.js"></script>
